export class InvCyclicEntity{
    id:number;
    name:string;
    typeSampling:string;
    sampling:number;
    total:number;
    system:string;
    crossSap:boolean;
    crossWms:boolean;
    crossBase:boolean;
    principalSystem:string;
    creationDate:string;
    status:string;
    countryId:number;
    country:string;
    customerId:number;
    customer:string;
    personId:number;
    active:boolean;

    constructor(){}
}